<template>
  <div class="swiperbox">
    <swiper
      :slidesPerView="1"
      :spaceBetween="30"
      :loop="true"
      :centeredSlides="true"
      :pagination="{ clickable: true}"
      :autoplay="{ delay: 2500, disableOnInteraction: false}"
      :navigation="true"
      :modules="modules"
      class="swiperbox"
    >
      <swiper-slide>
        <img src="@/assets/image/1.webp" alt />
      </swiper-slide>
      <swiper-slide>
        <img src="@/assets/image/2.webp" alt />
      </swiper-slide>
      <swiper-slide>
        <img src="@/assets/image/3.webp" alt />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue"; // swiper 所需组件
import { Autoplay, Navigation, Pagination, A11y } from "swiper"; // 分页器
import "swiper/swiper-bundle.css";

const modules = [Autoplay, Pagination, Navigation, A11y];
</script>

<style scoped lang="less">
.swiperbox {
  width: 100%;
  height: 64.25rem;
  // height: 100vh;
  img {
    width: 120rem;
    height: 64.25rem;
  }
}
</style>
